import Axios from 'axios';
import { ROUTES } from '../helpers/constants/constants';
import { deleteCookie } from '../helpers/pure-functions';
import { isTokenExpiringSoon, performTokenRefresh, clearAuthTokens, clearTokenRefreshTimer } from '../helpers/token-refresh';

export const getBearer = () => `Bearer ${localStorage.getItem('bearer')}`;

// Request interceptor: check token expiration before each API call
Axios.interceptors.request.use(
  async (config) => {
    // Skip token refresh check for oauth endpoints to avoid infinite loop
    if (config.url?.includes('/oauth/token')) {
      return config;
    }

    // Only check if we have a token and it's expiring soon
    if (localStorage.getItem('bearer') && isTokenExpiringSoon(5)) {
      try {
        await performTokenRefresh();
        // Update the request's auth header with the fresh token
        config.headers.Authorization = getBearer();
      } catch (error) {
        console.error('Pre-request token refresh failed:', error);
        // Let the request proceed - the response interceptor will handle 401
      }
    }

    return config;
  },
  error => Promise.reject(error)
);

// Response interceptor: handle auth errors
Axios.interceptors.response.use(
  response => response,
  error => {
    console.error(error);

    if (error.response) {
      const ERROR_LIST = error?.response?.data?.errors || [];
      if (ERROR_LIST.some(({code}) => ['QCS-0500', 'QCS-0401-2'].includes(code))) {
        clearTokenRefreshTimer();
        clearAuthTokens();
        deleteCookie('qkn_bearer');
        const retainPromo = localStorage.getItem('bmPromos');
        localStorage.clear();
        if(retainPromo) {
          localStorage.setItem('bmPromos', retainPromo);
        }

        window.location = ROUTES.LOGIN;
      }
    }

    return Promise.reject(error);
  });
